import { motion } from "framer-motion";
import { useState } from "react";
import { ArrowRightIcon } from "../utils/icons";

// Full list of hair care tips
const allHairCareTips = [
  // Treatment Tips
  {
    id: 1,
    title: "Deep Conditioning Magic",
    shortDescription:
      "Transform your hair's health with weekly deep conditioning",
    description:
      "Deep conditioning is crucial for maintaining healthy natural hair. Apply your deep conditioner to clean, damp hair and use a heating cap for better penetration. Leave it on for 15-30 minutes for best results. For extra benefits, mix in some of our Growth Oil Blend with your deep conditioner.",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946380/IMG_9547_sdmx5k.jpg",
    category: "Treatment",
    readTime: "3 min read",
  },
  {
    id: 2,
    title: "Hot Oil Treatment Guide",
    shortDescription:
      "Revitalize your scalp and strands with hot oil treatments",
    description:
      "Hot oil treatments help stimulate the scalp and nourish hair from root to tip. Warm your favorite hair oil (like our Growth Oil Blend) slightly, massage into your scalp and distribute through your hair. Cover with a heating cap for 30 minutes before washing.",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946266/IMG_9572_yg7syq.jpg",
    category: "Treatment",
    readTime: "4 min read",
  },

  // Styling Tips
  {
    id: 3,
    title: "Protective Styling Guide",
    shortDescription:
      "Master the art of protective styling for length retention",
    description:
      "Protective styles help retain length by keeping your ends tucked away. Ensure your hair is well-moisturized before styling and don't install styles too tight. Remember to moisturize your scalp and edges regularly while in protective styles.",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946456/IMG_9533_vmkaby.jpg",
    category: "Styling",
    readTime: "4 min read",
  },
  {
    id: 4,
    title: "Twist-Out Techniques",
    shortDescription: "Perfect your twist-out for defined, bouncy curls",
    description:
      "For the perfect twist-out, start with freshly washed and deeply conditioned hair. Section your hair and apply our Moisture Lock Cream to each section. Twist in small to medium sections, and let dry completely before unraveling. Sleep with a satin bonnet to preserve the style.",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946517/Facetune_12-01-2025-11-32-15_tfp2a7.jpg",
    category: "Styling",
    readTime: "5 min read",
  },

  // Maintenance Tips
  {
    id: 5,
    title: "Nighttime Hair Care Routine",
    shortDescription: "Protect your hair while you sleep for better hair days",
    description:
      "Use a silk or satin pillowcase and bonnet to prevent friction and moisture loss while you sleep. This simple step can significantly reduce breakage. Before bed, lightly moisturize your hair and gently section it to prevent tangling.",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946345/IMG_9555_lpyrou.jpg",
    category: "Maintenance",
    readTime: "2 min read",
  },
  {
    id: 6,
    title: "Detangling Made Easy",
    shortDescription: "Learn proper detangling techniques to minimize breakage",
    description:
      "Always detangle your hair when it's wet and coated with conditioner. Use your fingers or a wide-tooth comb, starting from the ends and working your way up. Section your hair to make the process more manageable and take your time to prevent unnecessary breakage.",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741945966/IMG_9629_httwh5.jpg",
    category: "Maintenance",
    readTime: "3 min read",
  },

  // Growth Tips
  {
    id: 7,
    title: "Scalp Massage Techniques",
    shortDescription: "Stimulate hair growth with proper scalp massage",
    description:
      "Regular scalp massages increase blood flow to your hair follicles, promoting healthy hair growth. Use our Growth Oil Blend and massage your scalp for 5-10 minutes daily. Focus on areas where you want to see more growth and use gentle circular motions.",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946217/IMG_9580_dwtryb.jpg",
    category: "Growth",
    readTime: "3 min read",
  },
  {
    id: 8,
    title: "Growth-Promoting Diet",
    shortDescription: "Eat your way to longer, healthier hair",
    description:
      "A balanced diet rich in proteins, vitamins, and minerals is essential for hair growth. Include foods high in biotin, omega-3 fatty acids, and vitamin E. Stay hydrated and consider supplements after consulting with your healthcare provider.",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946087/IMG_9619_mrxbxp.jpg",
    category: "Growth",
    readTime: "4 min read",
  },

  // Moisture Tips
  {
    id: 9,
    title: "LOC Method Mastery",
    shortDescription: "Perfect the LOC method for maximum moisture retention",
    description:
      "The LOC (Liquid, Oil, Cream) method is key for moisture retention. Start with a water-based leave-in, follow with our Growth Oil Blend, and seal with our Moisture Lock Cream. Apply products to small sections of damp hair for best results.",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741945989/IMG_9623_koglsj.jpg",
    category: "Moisture",
    readTime: "4 min read",
  },
  {
    id: 10,
    title: "Hydration Techniques",
    shortDescription: "Keep your hair moisturized between wash days",
    description:
      "Maintain moisture by using a light water-based spray daily. Focus on your ends, which are the oldest and driest part of your hair. Seal with a light oil to lock in moisture. Remember to deep condition weekly and use a humidifier in dry climates.",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946126/IMG_9604_mckypx.jpg",
    category: "Moisture",
    readTime: "3 min read",
  },

  // Additional Tips for Each Category
  {
    id: 11,
    title: "Pre-Poo Treatment Guide",
    shortDescription:
      "Protect your hair during washing with pre-poo treatments",
    description:
      "Apply oil or conditioner to your hair before shampooing to protect it from the stripping effects of shampoo. Focus on your ends and leave the treatment on for 30 minutes before washing. This helps maintain moisture and reduces tangles.",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946456/IMG_9533_vmkaby.jpg",
    category: "Treatment",
    readTime: "3 min read",
  },
  {
    id: 12,
    title: "Bantu Knot Tutorial",
    shortDescription: "Create stunning defined curls with bantu knots",
    description:
      "Section clean, moisturized hair and twist each section before wrapping it around itself to form a knot. Secure with bobby pins if needed. Allow to dry completely before unraveling for beautiful, defined curls.",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946266/IMG_9572_yg7syq.jpg",
    category: "Styling",
    readTime: "5 min read",
  },
  {
    id: 13,
    title: "Weekly Maintenance Schedule",
    shortDescription: "Create an effective hair care routine",
    description:
      "Develop a consistent weekly routine including wash day, deep conditioning, and styling. Plan your styles ahead and prepare your products the night before. This helps ensure you're giving your hair the care it needs regularly.",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946380/IMG_9547_sdmx5k.jpg",
    category: "Maintenance",
    readTime: "4 min read",
  },
  {
    id: 14,
    title: "Length Check Guide",
    shortDescription: "Track your hair growth progress effectively",
    description:
      "Take monthly progress pictures and measurements to track your hair growth. Use the same hairstyle and camera angle each time. Consider keeping a hair journal to note what practices are helping or hindering your growth journey.",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946345/IMG_9555_lpyrou.jpg",
    category: "Growth",
    readTime: "3 min read",
  },
  {
    id: 15,
    title: "Moisture Sealing Secrets",
    shortDescription: "Learn advanced techniques for moisture retention",
    description:
      "Beyond basic moisturizing, learn to layer products effectively. Use the greenhouse effect by applying products to damp hair and covering with a plastic cap for 30 minutes. This helps products penetrate deeper into the hair shaft.",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741945966/IMG_9629_httwh5.jpg",
    category: "Moisture",
    readTime: "4 min read",
  },
];

// Categories for filtering
const categories = [
  "All",
  "Treatment",
  "Styling",
  "Maintenance",
  "Growth",
  "Moisture",
];

export default function Tips() {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedTip, setSelectedTip] = useState(null);

  const filteredTips =
    selectedCategory === "All"
      ? allHairCareTips
      : allHairCareTips.filter((tip) => tip.category === selectedCategory);

  return (
    <div className="bg-gray-50 min-h-screen pt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Page Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl font-serif font-bold text-gray-900 mb-4">
            Hair Care Tips & Tricks
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Discover expert tips and tricks for maintaining healthy, beautiful
            natural hair. From daily maintenance to special treatments, we've
            got you covered.
          </p>
        </motion.div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <motion.button
              key={category}
              whileHover={{ y: -2 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => setSelectedCategory(category)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                selectedCategory === category
                  ? "bg-[#DB5461] text-white"
                  : "bg-white text-gray-600 hover:bg-[#DB5461]/10"
              }`}
            >
              {category}
            </motion.button>
          ))}
        </div>

        {/* Tips Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredTips.map((tip, index) => (
            <motion.div
              key={tip.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500"
              onClick={() => setSelectedTip(tip)}
            >
              {/* Image Container */}
              <div className="relative h-48 overflow-hidden">
                <motion.img
                  src={tip.image}
                  alt={tip.title}
                  className="w-full h-full object-cover"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.6 }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 text-xs font-medium text-white bg-[#DB5461]/90 rounded-full">
                    {tip.category}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="mb-4">
                  <h3 className="text-xl font-serif font-bold text-gray-900 mb-2 group-hover:text-[#DB5461] transition-colors duration-300">
                    {tip.title}
                  </h3>
                  <p className="text-gray-600 line-clamp-2">
                    {tip.shortDescription}
                  </p>
                </div>

                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500">{tip.readTime}</span>
                  <motion.div
                    whileHover={{ x: 4 }}
                    className="text-[#DB5461] flex items-center gap-1 text-sm font-medium cursor-pointer"
                  >
                    Read More
                    <ArrowRightIcon className="w-4 h-4" />
                  </motion.div>
                </div>
              </div>

              {/* Decorative Elements */}
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-[#DB5461]/20 rounded-2xl transition-all duration-300" />
            </motion.div>
          ))}
        </div>

        {/* Tip Modal */}
        {selectedTip && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
            onClick={() => setSelectedTip(null)}
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="relative">
                <img
                  src={selectedTip.image}
                  alt={selectedTip.title}
                  className="w-full h-64 object-cover"
                />
                <button
                  onClick={() => setSelectedTip(null)}
                  className="absolute top-4 right-4 bg-white/90 p-2 rounded-full hover:bg-white transition-colors duration-300"
                >
                  <svg
                    className="w-6 h-6 text-gray-900"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <div className="p-6">
                <span className="px-3 py-1 text-xs font-medium text-[#DB5461] bg-[#DB5461]/10 rounded-full">
                  {selectedTip.category}
                </span>
                <h2 className="text-2xl font-serif font-bold text-gray-900 mt-4 mb-2">
                  {selectedTip.title}
                </h2>
                <p className="text-gray-600">{selectedTip.description}</p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </div>
    </div>
  );
}
